import { render, staticRenderFns } from "./LayoutNavbarHorizontal.vue?vue&type=template&id=3f18a4aa&v-slot%3Aextension=true&"
import script from "./LayoutNavbarHorizontal.vue?vue&type=script&lang=ts&"
export * from "./LayoutNavbarHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutNavbarHorizontal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs,VTabsSlider})
